import { atom } from "recoil";

export const StatusDuAnState = atom({
  key: "StatusDuAnState",
  default: undefined,
});

export const StatusKhuCumState = atom({
  key: "StatusKhuCumState",
  default: undefined,
});
